import React from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';

import { config } from '@config/pendo.config.json';
import { primary } from 'styles/global_defaults/colors';
import { openSans, textMediumFontSize } from 'styles/global_defaults/fonts';
import { halfSpacing, largeSpacing } from 'styles/global_defaults/scaffolding';

type Props = {
  onRevise: () => void;
};

const styles = css`
  display: flex;
  padding: ${halfSpacing}px ${largeSpacing}px;

  button {
    background: none;
    border: none;
    padding: 0;
    font-family: ${openSans};
    font-size: ${textMediumFontSize}px;
    color: ${primary};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const ReviseLink: React.FC<Props> = ({ onRevise }) => (
  <div css={styles}>
    <button
      type='button'
      onClick={onRevise}
      data-qa={config.pendo.submissionView.aiInsights.reviseSubmission}
    >
      {t.SUBMISSIONS.AI_ASSIGNMENT.REVISE_SUBMISSION()}
    </button>
  </div>
);

export default ReviseLink;
